"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var auth_1 = require("firebase/auth");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var FaceTecSDK_1 = require("../../../core-sdk/FaceTecSDK.js/FaceTecSDK");
var AdditionalScreens_1 = require("../../../facetec/src/utilities/AdditionalScreens");
var DeveloperStatusMessages_1 = require("../../../facetec/src/utilities/DeveloperStatusMessages");
var SampleAppUtilities_1 = require("../../../facetec/src/utilities/SampleAppUtilities");
var ThemeHelpers_1 = require("../../../facetec/src/utilities/ThemeHelpers");
var get__production_keys_1 = require("../../api/calls/sky_api/get_ production_keys");
var get_firebase_user_profile_1 = require("../../api/calls/user/get_firebase_user_profile");
var Config_1 = require("../../Config");
var verification_copy_1 = require("../../constants/verification_copy");
var auth_2 = require("../../features/slices/auth");
var user_profile_1 = require("../../features/slices/user-profile");
var content_dialog_1 = require("../../features/thunks/content-dialog");
var logout_1 = require("../../features/thunks/logout");
var facetec_1 = require("../../screens/facetec-auth/facetec");
var auth_persistence_1 = require("../../utils/auth-persistence");
var firebase_1 = require("../../utils/firebase");
var user_state_1 = require("../../utils/user-state");
var auth_modal_manager_1 = require("../auth-modal-manager");
function userHasAdminPermission(permissions) {
    if (!permissions)
        return false;
    if ((permissions === null || permissions === void 0 ? void 0 : permissions.admin) === true) {
        return true;
    }
    return false;
}
var AdminLayout = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var auth = (0, react_redux_1.useSelector)(function (state) { return state.auth; });
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.userProfile; }), userProfile = _a.profile, userProfileLoaded = _a.loaded, userProfileError = _a.error;
    var firebaseProfile = (0, react_redux_1.useSelector)(function (state) {
        return state.userProfile.profile;
    });
    var facetecState = (0, react_redux_1.useSelector)(function (state) { return state.userProfile.facetec; });
    var _b = (0, react_1.useState)(false), isAuthModalOpen = _b[0], setIsAuthModalOpen = _b[1];
    var _c = (0, react_1.useState)("login"), adminInitialModal = _c[0], setAdminInitialModal = _c[1];
    var _d = (0, react_1.useState)(false), sdkInitialized = _d[0], setSdkInitialized = _d[1];
    var _e = (0, react_1.useState)(0), initializationCount = _e[0], setInitializationCount = _e[1];
    var _f = (0, react_1.useState)(false), showBiometricBanner = _f[0], setShowBiometricBanner = _f[1];
    var _g = (0, react_1.useState)(false), isBiometricAuthed = _g[0], setIsBiometricAuthed = _g[1];
    var _h = (0, react_1.useState)(false), showInlineFaceTec = _h[0], setShowInlineFaceTec = _h[1];
    var _j = (0, react_1.useState)(false), isUserMenuOpen = _j[0], setIsUserMenuOpen = _j[1];
    var userMenuRef = (0, react_1.useRef)(null);
    var branding = (0, react_1.useMemo)(function () { return ({
        logo: "",
        primaryColor: "#dc2626",
        secondaryColor: "#111827",
        accentColor: "#111827",
    }); }, []);
    var siteName = "LEWFIN Admin";
    var userDisplayName = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        var profileName = (_a = firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.name) === null || _a === void 0 ? void 0 : _a.trim();
        if (profileName) {
            return profileName;
        }
        var profileDisplay = (_b = firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.display_name) === null || _b === void 0 ? void 0 : _b.trim();
        if (profileDisplay) {
            return profileDisplay;
        }
        var combinedName = [auth.name, auth.surname]
            .filter(Boolean)
            .join(" ")
            .trim();
        if (combinedName) {
            return combinedName;
        }
        var emailSource = ((_c = firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.email) === null || _c === void 0 ? void 0 : _c.trim()) || ((_d = auth.email) === null || _d === void 0 ? void 0 : _d.trim()) || "";
        return emailSource;
    }, [
        auth.email,
        auth.name,
        auth.surname,
        firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.display_name,
        firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.email,
        firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.name,
    ]);
    var userInitial = (0, react_1.useMemo)(function () {
        var source = userDisplayName || auth.email || (firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.email) || "";
        if (!source) {
            return "A";
        }
        var trimmed = source.trim();
        return trimmed.length > 0 ? trimmed.charAt(0).toUpperCase() : "A";
    }, [auth.email, firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.email, userDisplayName]);
    var accountLabel = userDisplayName || auth.email || (firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.email) || "Account";
    var hasAdminPermission = (0, react_1.useMemo)(function () { return userHasAdminPermission((firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.permissions) || {}); }, [firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.permissions]);
    var isCheckingAdminPermission = Boolean(auth.access_token) && !userProfileLoaded;
    var isActiveRoute = function (path) {
        return location.pathname === path;
    };
    (0, react_1.useEffect)(function () {
        if (!isUserMenuOpen) {
            return;
        }
        var handleDocumentClick = function (event) {
            if (userMenuRef.current &&
                !userMenuRef.current.contains(event.target)) {
                setIsUserMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleDocumentClick);
        return function () {
            document.removeEventListener("mousedown", handleDocumentClick);
        };
    }, [isUserMenuOpen]);
    (0, react_1.useEffect)(function () {
        if (!auth.access_token) {
            setIsUserMenuOpen(false);
        }
    }, [auth.access_token]);
    // Initialize FaceTec SDK for Admin routes too
    (0, react_1.useEffect)(function () {
        var initFaceTecProcesses = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, content, key, domains, expiryDate, keyText, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, get__production_keys_1.get_production_keys)({ is_web: true })];
                    case 1:
                        response = _a.sent();
                        content = response && response.status === 200 && response.data
                            ? response.data.content
                            : response && response.data && response.data.content
                                ? response.data.content
                                : null;
                        if (content) {
                            key = content.keys;
                            domains = key.domains;
                            expiryDate = key.expiryDate;
                            keyText = key.key;
                            Config_1.Config.ProductionKeyText = "{ \"domains\": \"".concat(domains, "\", \"expiryDate\": \"").concat(expiryDate, "\", \"key\": \"").concat(keyText, "\"}");
                            Config_1.Config.DeviceKeyIdentifier = content.key_identifier;
                            if (Config_1.Config.ProductionKeyText && Config_1.Config.DeviceKeyIdentifier) {
                                // Ensure absolute resource directories so nested routes don't break asset paths
                                FaceTecSDK_1.FaceTecSDK.setResourceDirectory("/facetec/resources");
                                FaceTecSDK_1.FaceTecSDK.setImagesDirectory("/facetec/images");
                                Config_1.Config.initializeFromAutogeneratedConfig(FaceTecSDK_1.FaceTecSDK, function (initializedSuccessfully) {
                                    if (initializedSuccessfully)
                                        setInitializationCount(function (c) { return c + 1; });
                                    setSdkInitialized(initializedSuccessfully);
                                }, Config_1.Config.ProductionKeyText, Config_1.Config.DeviceKeyIdentifier);
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error loading providers:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        initFaceTecProcesses();
    }, []);
    (0, react_1.useEffect)(function () {
        if (sdkInitialized) {
            Config_1.Config.didSucceed = sdkInitialized;
            onFaceTecSDKInitializationSuccess();
        }
        else if (initializationCount === 0 && !sdkInitialized) {
            Config_1.Config.didSucceed = sdkInitialized;
            onFaceTecSDKInitializationFailure();
        }
    }, [sdkInitialized]);
    // Prompt login when unauthenticated
    (0, react_1.useEffect)(function () {
        setIsAuthModalOpen(!auth.access_token);
    }, [auth.access_token]);
    // Ensure we have the latest Firebase profile for permission checks
    // Use the same authoritative UID chain as app.tsx (ADR: Firebase Auth UID is authoritative)
    (0, react_1.useEffect)(function () {
        var _a;
        if (!auth.access_token || userProfileLoaded) {
            return;
        }
        var currentUserUid = (_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid;
        var firebaseUid = currentUserUid ||
            auth.firebase_user_id ||
            localStorage.getItem("firebase_user_id");
        if (!firebaseUid) {
            dispatch((0, user_profile_1.setUserProfileError)("Missing Firebase user id"));
            return;
        }
        // Sync localStorage when UID came from an authoritative source
        if (currentUserUid) {
            localStorage.setItem("firebase_user_id", currentUserUid);
        }
        var cancelled = false;
        (0, get_firebase_user_profile_1.get_firebase_user_profile)(firebaseUid).then(function (res) {
            var _a, _b;
            if (cancelled) {
                return;
            }
            if (res.success && res.content) {
                // get_firebase_user_profile returns { raw, sanitized } — use sanitized
                var profile = (_b = (_a = res.content.sanitized) !== null && _a !== void 0 ? _a : res.content.raw) !== null && _b !== void 0 ? _b : res.content;
                dispatch((0, user_profile_1.setFirebaseUserProfile)(profile));
                if (profile === null || profile === void 0 ? void 0 : profile.facetecDBRef) {
                    dispatch((0, auth_2.setFacetecDBRef)(profile.facetecDBRef));
                }
            }
            else {
                dispatch((0, user_profile_1.setUserProfileError)(res.message || "Unable to load profile"));
            }
        });
        return function () {
            cancelled = true;
        };
    }, [auth.access_token, auth.firebase_user_id, dispatch, userProfileLoaded]);
    // Track FaceTec status and gate admin UI when not authenticated
    (0, react_1.useEffect)(function () {
        if (!auth.access_token || !hasAdminPermission) {
            setShowBiometricBanner(false);
            setIsBiometricAuthed(false);
            setShowInlineFaceTec(false);
            dispatch((0, content_dialog_1.closeContentDialogThunk)());
            return;
        }
        var authed = (facetecState === null || facetecState === void 0 ? void 0 : facetecState.authenticated) === true;
        setIsBiometricAuthed(authed);
        setShowBiometricBanner(!authed);
        if (!authed) {
            setShowInlineFaceTec(true);
            dispatch((0, content_dialog_1.showContentDialogThunk)({
                header: verification_copy_1.FACIAL_RECOGNITION,
                content: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}),
                width: "full",
                closable: false,
            }));
        }
        else {
            setShowInlineFaceTec(false);
            dispatch((0, content_dialog_1.closeContentDialogThunk)());
        }
    }, [auth.access_token, hasAdminPermission, facetecState === null || facetecState === void 0 ? void 0 : facetecState.authenticated]);
    var handleAuthSuccess = function (userData) {
        var _a, _b;
        // Update auth state just like navigation.tsx so restricted screen disappears
        if (userData.firebase && userData.user && userData.letsTradeToken) {
            // Sky Lifestyle signup flow
            dispatch((0, auth_2.setSkyCredentials)({
                user: userData.user,
                firebase: userData.firebase,
                letsTradeToken: userData.letsTradeToken,
            }));
            // Persist
            (0, auth_persistence_1.persistSkyAuthState)(userData.user, userData.firebase, userData.letsTradeToken);
        }
        else {
            // Regular login flow
            dispatch((0, auth_2.setCredentials)(userData));
            var rememberMe = userData.rememberMe || false;
            (0, auth_persistence_1.persistAuthState)(userData, rememberMe);
        }
        var firebaseUid = ((_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) ||
            ((_b = userData.user) === null || _b === void 0 ? void 0 : _b.firebaseId) ||
            userData.firebase_user_id ||
            localStorage.getItem("firebase_user_id");
        if (!firebaseUid) {
            dispatch((0, user_profile_1.setUserProfileError)("Missing Firebase user id"));
            setIsAuthModalOpen(false);
            return;
        }
        (0, get_firebase_user_profile_1.get_firebase_user_profile)(firebaseUid).then(function (res) {
            var _a, _b, _c;
            var sanitizedProfile;
            if (res.success && ((_a = res === null || res === void 0 ? void 0 : res.content) === null || _a === void 0 ? void 0 : _a.sanitized)) {
                sanitizedProfile = res.content.sanitized;
                dispatch((0, user_profile_1.setFirebaseUserProfile)(sanitizedProfile));
                var facetecDBRef = sanitizedProfile === null || sanitizedProfile === void 0 ? void 0 : sanitizedProfile.facetecDBRef;
                if (facetecDBRef) {
                    dispatch((0, auth_2.setFacetecDBRef)(facetecDBRef));
                }
                (0, user_state_1.setAuthenticatedFacetec)(false, false);
                if (!userHasAdminPermission(sanitizedProfile.permissions || {})) {
                    setShowInlineFaceTec(false);
                }
            }
            else {
                dispatch((0, user_profile_1.setUserProfileError)(res.message || "Failed to fetch profile"));
            }
            var hasAdmin = userHasAdminPermission((res.success && ((_c = (_b = res.content) === null || _b === void 0 ? void 0 : _b.sanitized) === null || _c === void 0 ? void 0 : _c.permissions)) ||
                (sanitizedProfile === null || sanitizedProfile === void 0 ? void 0 : sanitizedProfile.permissions) ||
                {});
            if (hasAdmin) {
                if (!(facetecState === null || facetecState === void 0 ? void 0 : facetecState.authenticated)) {
                    dispatch((0, content_dialog_1.showContentDialogThunk)({
                        header: verification_copy_1.FACIAL_RECOGNITION,
                        content: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}),
                        width: "full",
                        closable: false,
                    }));
                }
                else {
                    setShowBiometricBanner(false);
                    setShowInlineFaceTec(false);
                    dispatch((0, content_dialog_1.closeContentDialogThunk)());
                }
            }
            else {
                dispatch((0, content_dialog_1.closeContentDialogThunk)());
                setShowBiometricBanner(false);
                setIsBiometricAuthed(false);
                setShowInlineFaceTec(false);
            }
            setIsAuthModalOpen(false);
        });
    };
    var handleLogout = (0, react_1.useCallback)(function () {
        dispatch((0, logout_1.logoutThunk)())
            .unwrap()
            .then(function () {
            (0, auth_1.signOut)(firebase_1.auth).catch(function (error) {
                console.warn("Firebase sign-out failed:", error);
            });
            localStorage.removeItem("firebase_user_id");
            (0, user_state_1.setAuthenticatedFacetec)(false, false);
            dispatch((0, user_profile_1.clearFirebaseUserProfile)());
            dispatch((0, user_profile_1.clearFaceTecActions)());
            dispatch((0, content_dialog_1.closeContentDialogThunk)());
            setIsUserMenuOpen(false);
            setShowBiometricBanner(false);
            setShowInlineFaceTec(false);
            setIsBiometricAuthed(false);
        })
            .catch(function () {
            // User cancelled logout via confirmation dialog
        });
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "min-h-screen bg-gray-50", children: [(0, jsx_runtime_1.jsx)("header", { className: "bg-white shadow-sm border-b border-gray-200", children: (0, jsx_runtime_1.jsx)("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between items-center py-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-8", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-2xl font-bold text-gray-900", children: "LEWFIN Admin" }), (0, jsx_runtime_1.jsx)("nav", { className: "hidden md:flex space-x-6", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/admin", className: "px-3 py-2 rounded-md text-sm font-medium transition-colors ".concat(isActiveRoute("/admin")
                                                ? "bg-blue-100 text-blue-700"
                                                : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"), children: "Dashboard" }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex items-center space-x-4", children: auth.access_token ? ((0, jsx_runtime_1.jsxs)("div", { className: "relative", ref: userMenuRef, children: [(0, jsx_runtime_1.jsxs)("button", { onClick: function () { return setIsUserMenuOpen(function (open) { return !open; }); }, className: "flex items-center space-x-2 px-3 py-2 rounded-md border border-gray-200 hover:bg-gray-50 transition-colors", children: [(0, jsx_runtime_1.jsx)("div", { className: "h-8 w-8 bg-blue-600 rounded-full flex items-center justify-center", children: (0, jsx_runtime_1.jsx)("span", { className: "text-white text-sm font-semibold", children: userInitial }) }), (0, jsx_runtime_1.jsx)("span", { className: "hidden sm:block text-sm font-medium text-gray-700", children: accountLabel }), (0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4 text-gray-500", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }) })] }), isUserMenuOpen && ((0, jsx_runtime_1.jsxs)("div", { className: "absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg overflow-hidden z-50", children: [(0, jsx_runtime_1.jsxs)("div", { className: "px-4 py-3 border-b border-gray-100", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm font-semibold text-gray-900", children: accountLabel }), auth.email && ((0, jsx_runtime_1.jsx)("p", { className: "text-xs text-gray-500 truncate", children: auth.email }))] }), (0, jsx_runtime_1.jsx)("button", { onClick: handleLogout, className: "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors", children: "Log Out" })] }))] })) : ((0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                        setAdminInitialModal("login");
                                        setIsAuthModalOpen(true);
                                    }, className: "px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors", children: "Sign In" })) })] }) }) }), (0, jsx_runtime_1.jsx)("main", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8", children: !auth.access_token ? ((0, jsx_runtime_1.jsx)("div", { className: "min-h-[60vh] flex items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "max-w-xl w-full bg-white rounded-2xl shadow-lg p-10 text-center border border-gray-100", children: [(0, jsx_runtime_1.jsx)("div", { className: "inline-flex items-center justify-center w-12 h-12 rounded-full mb-4", style: { backgroundColor: branding.primaryColor, opacity: 0.1 }, children: (0, jsx_runtime_1.jsx)("span", { className: "text-xl font-bold", style: { color: branding.primaryColor }, children: "!" }) }), (0, jsx_runtime_1.jsx)("h2", { className: "text-2xl font-bold text-gray-900 mb-2", children: "Restricted Area" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-600 mb-6", children: "Please sign in or create an account to access LEWFIN Admin." }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-center gap-4", children: [(0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                            setAdminInitialModal("login");
                                            setIsAuthModalOpen(true);
                                        }, className: "px-6 py-2.5 rounded-lg text-white shadow-sm hover:opacity-90 transition", style: { backgroundColor: branding.primaryColor }, children: "Sign In" }), (0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                            setAdminInitialModal("signup");
                                            setIsAuthModalOpen(true);
                                        }, className: "px-6 py-2.5 rounded-lg border transition", style: {
                                            borderColor: branding.primaryColor,
                                            color: branding.primaryColor,
                                        }, onMouseEnter: function (e) {
                                            e.currentTarget.style.backgroundColor = branding.primaryColor;
                                            e.currentTarget.style.color =
                                                "#ffffff";
                                        }, onMouseLeave: function (e) {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color =
                                                branding.primaryColor;
                                        }, children: "Sign Up" })] }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-gray-400 mt-4", children: "Facial Recognition is required after sign in/sign up." })] }) })) : isCheckingAdminPermission ? ((0, jsx_runtime_1.jsx)("div", { className: "min-h-[60vh] flex items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "max-w-xl w-full bg-white rounded-2xl shadow-inner p-10 text-center border border-blue-100", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-semibold text-gray-900 mb-2", children: "Checking Permissions" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-600", children: "Please wait while we confirm your admin access." })] }) })) : userProfileError ? ((0, jsx_runtime_1.jsx)("div", { className: "min-h-[60vh] flex items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "max-w-xl w-full bg-white rounded-2xl shadow-inner p-10 text-center border border-red-200", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-semibold text-gray-900 mb-2", children: "Unable to verify admin access" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-600 mb-4", children: userProfileError }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-500", children: "If you have a direct site link you can still open it, or contact your administrator for help." })] }) })) : !hasAdminPermission ? ((0, jsx_runtime_1.jsx)("div", { className: "min-h-[60vh] flex items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "max-w-xl w-full bg-white rounded-2xl shadow-lg p-10 text-center border border-gray-100", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-2xl font-bold text-gray-900 mb-2", children: "Admin Permission Required" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-600 mb-4", children: "Your account does not include the admin permission needed to view this dashboard." }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-500", children: "You can still navigate directly to your site or request access from your administrator." })] }) })) : !isBiometricAuthed ? ((0, jsx_runtime_1.jsx)("div", { className: "min-h-[60vh] flex items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "max-w-xl w-full bg-white rounded-2xl shadow-inner p-10 text-center border border-yellow-200", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-semibold text-gray-900 mb-2", children: "Facial Recognition Required" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-600 mb-6", children: "Please complete Facial Recognition to continue." }), (0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                    setShowInlineFaceTec(true);
                                    dispatch((0, content_dialog_1.showContentDialogThunk)({
                                        header: verification_copy_1.FACIAL_RECOGNITION,
                                        content: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}),
                                        width: "full",
                                        closable: false,
                                    }));
                                }, className: "px-6 py-2.5 rounded-lg text-white shadow-sm hover:opacity-90 transition", style: { backgroundColor: branding.primaryColor }, children: "Start Facial Recognition" }), showInlineFaceTec && ((0, jsx_runtime_1.jsx)("div", { className: "mt-6", children: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}) }))] }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showBiometricBanner && ((0, jsx_runtime_1.jsxs)("div", { className: "mb-6 p-4 rounded-md border border-yellow-300 bg-yellow-50 text-yellow-900 flex items-center justify-between", children: [(0, jsx_runtime_1.jsx)("div", { className: "mr-4 font-medium", children: "Admin access requires completing a Facial Recognition scan." }), (0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                        setShowInlineFaceTec(true);
                                        dispatch((0, content_dialog_1.showContentDialogThunk)({
                                            header: verification_copy_1.FACIAL_RECOGNITION,
                                            content: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}),
                                            width: "full",
                                            closable: false,
                                        }));
                                    }, className: "px-4 py-2 rounded text-white", style: { backgroundColor: "#d97706" }, children: "Start Facial Recognition" })] })), showInlineFaceTec && !isBiometricAuthed && ((0, jsx_runtime_1.jsx)("div", { className: "mb-6", children: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] })) }), (0, jsx_runtime_1.jsx)(auth_modal_manager_1.AuthModalManager, { isOpen: isAuthModalOpen, onClose: function () { return setIsAuthModalOpen(false); }, branding: branding, siteName: siteName, initialModal: adminInitialModal, onAuthSuccess: handleAuthSuccess })] }));
};
exports.AdminLayout = AdminLayout;
// Local copies of initialization handlers (kept in-sync with navigation.tsx)
function onFaceTecSDKInitializationSuccess() {
    SampleAppUtilities_1.SampleAppUtilities.enableControlButtons();
    // Ensure resource/image directories are absolute so nested routes resolve correctly
    FaceTecSDK_1.FaceTecSDK.setResourceDirectory("/facetec/resources");
    FaceTecSDK_1.FaceTecSDK.setImagesDirectory("/facetec/images");
    ThemeHelpers_1.ThemeHelpers.setAppTheme(ThemeHelpers_1.ThemeHelpers.getCurrentTheme());
    SampleAppUtilities_1.SampleAppUtilities.setVocalGuidanceSoundFiles();
    SampleAppUtilities_1.SampleAppUtilities.setOCRLocalization();
    if (document.getElementById("controls") !== null) {
        AdditionalScreens_1.AdditionalScreens.setServerUpgradeStyling(document.getElementById("controls"), exitAdditionalScreen);
    }
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
}
function onFaceTecSDKInitializationFailure() {
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
}
function exitAdditionalScreen() {
    AdditionalScreens_1.AdditionalScreens.exitAdditionalScreen(SampleAppUtilities_1.SampleAppUtilities.showMainUI);
}
